import { ReadonlyPageBlockProps } from "organisms/page-blocks/readonly-page-block/readonly-page-block";
import { ReadonlyPageBlockContent } from "organisms/page-blocks/readonly-page-block/readonly-page-block-content";
import React from "react";

interface DefaultReadonlyPageBlockProps extends ReadonlyPageBlockProps {}

export const DefaultReadonlyPageBlock: React.FC<
    DefaultReadonlyPageBlockProps
> = (props: DefaultReadonlyPageBlockProps): JSX.Element => (
    <ReadonlyPageBlockContent {...props} additionalBlockData={{}} />
);
